var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { uniqueBy } from '../utils/uniqueBy.js';
import { computeWalletConnectMetaData } from '../utils/computeWalletConnectMetaData.js';
import { omitUndefinedValues } from '../utils/omitUndefinedValues.js';
export const connectorsForWallets = (walletList, { projectId, walletConnectParameters, appName, appDescription, appUrl, appIcon }) => {
    if (!walletList.length) {
        throw new Error('No wallet list was provided');
    }
    let index = -1;
    const connectors = [];
    const wallets = [];
    const walletConnectMetaData = computeWalletConnectMetaData({
        appName,
        appDescription,
        appUrl,
        appIcon,
    });
    walletList.forEach(createWallet => {
        index++;
        const wallet = createWallet({
            projectId,
            appName,
            appIcon,
            // `option` is being used only for `walletConnectWallet` wallet
            options: Object.assign({ metadata: walletConnectMetaData }, walletConnectParameters),
            // Every other wallet that supports walletConnect flow and is not
            // `walletConnectWallet` wallet will have `walletConnectParameters` property
            walletConnectParameters: Object.assign({ metadata: walletConnectMetaData }, walletConnectParameters),
        });
        const walletListItem = Object.assign(Object.assign({}, wallet), { index });
        wallets.push(walletListItem);
    });
    // Filtering out duplicated wallets in case there is any.
    // We process the known visible wallets first so that the potentially
    // hidden wallets have access to the complete list of resolved wallets
    const walletListItems = uniqueBy([...wallets], 'id');
    for (let _a of walletListItems) {
        const { createConnector } = _a, walletMeta = __rest(_a, ["createConnector"]);
        const walletMetaData = (
        // For now we should only use these as the additional parameters
        additionalCapsuleParams) => {
            return {
                capsuleDetails: omitUndefinedValues(Object.assign(Object.assign(Object.assign({}, walletMeta), { isCapsuleConnector: true }), (additionalCapsuleParams ? additionalCapsuleParams : {}))),
            };
        };
        const isWalletConnectConnector = walletMeta.id === 'walletConnect';
        if (isWalletConnectConnector) {
            connectors.push(createConnector(walletMetaData({
                isWalletConnectModalConnector: true,
                showQrModal: true,
            })));
        }
        if (createConnector) {
            connectors.push(createConnector(walletMetaData()));
        }
    }
    return connectors;
};
